
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Navimumbaitopunecab() {



    const cardData =
    {
        keyword: 'Navi Mumbai to Pune Cab',
        heading: 'Meghana Cab : Navi Mumbai to Pune Cab',
        headingDescription: 'Meghana Cab offers Navi Mumbai to Pune Cab services, ensuring a fast, safe, and comfortable journey between these two major cities. Whether you’re traveling for work, education, medical appointments, or a weekend trip, our clean, air-conditioned cabs with experienced drivers guarantee a smooth and timely ride. Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your travel needs and group size. Enjoy doorstep pickup, transparent fares, and 24/7 customer support for a hassle-free experience. Book your Navi Mumbai to Pune Cab with Meghana Cab and travel in comfort, reliability, and peace of mind.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 as the seat of the Maratha Peshwas, this iconic fortification features grand teak gateways, granite walls, ornate fountains, and remnants of its former glory. Despite a destructive fire in 1828, the five surviving gates—like the Delhi and Mastani Darwaza—and the palace ruins offer a journey into Maratha power and intrigue, often brought to life during the evening light-and-sound show." 
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 with Italian arches and set amidst sprawling lawns, this palatial structure served both famine relief and later the Indian freedom struggle—Mahatma Gandhi and his family were interned here. Now a museum, it preserves Gandhi’s personal items and the samadhis of Kasturba Gandhi and Mahadev Desai, echoing India’s fight for independence." 
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched at 1,317 m on the Sahyadri range, this ancient hill fortress—famed for the 1670 Battle of Sinhagad—offers rugged treks, two main gateways (Pune & Kalyan Darwaza), Tanaji Malusare’s memorial, and sweeping vistas of the Deccan Plateau. It’s a beloved weekend trek with food stalls serving local fare." 
  },
  {
    "title": "Osho Ashram (Meditation Resort)",
    "description": "Nestled in lush Koregaon Park, this global meditation centre promotes wellness through guided meditations, yoga, therapies, and silent retreats. Housed in serene halls with beautifully maintained gardens, it provides a space for introspection and rejuvenation." 
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th‑century monolithic rock‑cut Shiva temple carved from basalt, this subterranean sanctum includes a circular Nandi mandapa with intricately carved pillars and a unique ‘underworld’ symbolism, all nestled within a peaceful urban heritage setting." 
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most celebrated sacred sites, this temple houses a lavishly adorned gold Ganesh idol and draws devotees year‑round. During Ganesh Chaturthi, its vibrant rituals, processions, and communal spirit make it a cultural highlight." 
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second‑highest hill at ~2,100 ft, crowned by the historic Peshwa-era Parvati Temple. A 103-step climb rewards visitors with rooftop city views, a small museum, and serene gardens—popular at sunrise and for spiritual solace." 
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Housing 20,000+ artifacts—ranging from decorative arts to musical instruments—this museum offers a vivid window into daily life in historical India. It recently introduced geofenced multilingual audio guides across its eight galleries. " 
  },
  {
    "title": "Shinde Chhatri",
    "description": "A memorial dedicated to Maratha warrior Mahadji Shinde (d.1794), featuring Rajasthani-style carved pavilions, colored glass windows, and serene courtyards. It marks both his cremation spot and enduring legacy." 
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spanning 130 acres at Pune’s edge, this family-friendly park includes a zoo, snake park, aviary, and botanical sections. It combines wildlife conservation with educational exhibits and picnic spaces." 
  }
],

"services": [
  {
    "name": "Navi Mumbai to Pune One Way Cab",
    "description": "Experience a smooth and hassle-free one-way cab journey from Navi Mumbai to Pune. Our service ensures punctual pickups, clean and well-maintained vehicles, and professional drivers who prioritize your comfort and safety throughout the trip. Whether it’s a business meeting or a personal visit, we make your travel effortless and enjoyable."
  },
  {
    "name": "Round Trip Cab Navi Mumbai to Pune",
    "description": "Plan your round trip travel between Navi Mumbai and Pune with our flexible and reliable cab services. Ideal for day trips or extended stays, we offer comfortable vehicles, courteous drivers, and customized packages to fit your itinerary. Enjoy a seamless experience from start to finish, with door-to-door service and competitive pricing."
  },
  {
    "name": "Cab from Vashi to Pune",
    "description": "Book a convenient and reliable cab from Vashi to Pune with experienced drivers who know the best routes to get you to your destination on time. Our vehicles are regularly sanitized and equipped with modern amenities, ensuring a comfortable and safe ride every time."
  },
  {
    "name": "Panvel to Pune Taxi",
    "description": "Travel from Panvel to Pune in comfort and style with our professional taxi service. Whether for business or leisure, our well-maintained cars and skilled drivers provide a relaxing journey tailored to your needs. Enjoy hassle-free bookings and transparent pricing."
  },
  {
    "name": "Affordable Cabs Navi Mumbai to Pune",
    "description": "Make your trip from Navi Mumbai to Pune affordable without compromising on quality. Our budget-friendly cabs offer safe, clean, and comfortable rides perfect for solo travelers, families, or groups. Benefit from competitive rates, flexible schedules, and prompt customer support."
  },
  {
    "name": "AC Taxi Navi Mumbai to Pune",
    "description": "Beat the heat with our air-conditioned taxi service from Navi Mumbai to Pune. Enjoy a cool and refreshing ride in our modern, well-maintained AC vehicles, driven by courteous professionals dedicated to ensuring your journey is comfortable and relaxing."
  },
  {
    "name": "Online Cab Booking Navi Mumbai to Pune",
    "description": "Book your cab from Navi Mumbai to Pune effortlessly through our secure and user-friendly online platform. Choose your preferred vehicle type, schedule your pickup, and get instant confirmation. Experience the convenience of digital bookings combined with reliable customer service."
  },
  {
    "name": "Sedan & SUV Hire Navi Mumbai to Pune",
    "description": "Choose from a wide range of sedan and SUV options for your journey from Navi Mumbai to Pune. Whether you need a compact sedan for a solo trip or a spacious SUV for family and luggage, we have the perfect vehicle to match your needs, equipped with all modern comforts."
  },
  {
    "name": "Family Travel Cab Navi Mumbai to Pune",
    "description": "Make family travel easier and more comfortable with our dedicated family cabs from Navi Mumbai to Pune. Our vehicles offer ample space, safety features, and courteous drivers who understand the needs of family travelers, ensuring a pleasant and stress-free journey for everyone."
  },
  {
    "name": "Navi Mumbai to Pune Car Rental",
    "description": "Rent a car for your trip from Navi Mumbai to Pune with flexible rental durations and transparent pricing. Our well-maintained fleet includes a variety of vehicles, all driven by experienced chauffeurs who ensure your safety and convenience at every stage of your trip."
  },
  {
    "name": "Budget Taxi Navi Mumbai to Pune Route",
    "description": "Travel economically along the Navi Mumbai to Pune route with our budget taxi services. Offering reliable rides, clean vehicles, and professional drivers, our service is perfect for those looking for quality travel without stretching their budget."
  },
  {
    "name": "Quick Ride Navi Mumbai to Pune",
    "description": "Need a fast and efficient ride from Navi Mumbai to Pune? Our quick ride service ensures minimal waiting time, prompt pickups, and expert navigation to get you to your destination swiftly and safely, whether it’s for work or leisure."
  },
  {
    "name": "24/7 Cab Navi Mumbai to Pune",
    "description": "Our 24/7 cab service from Navi Mumbai to Pune is ready whenever you are. Day or night, get reliable transportation with professional drivers and well-maintained vehicles, ensuring your travel plans are never delayed or disrupted."
  },
  {
    "name": "Corporate Cab Navi Mumbai to Pune",
    "description": "Designed for business travelers, our corporate cab service from Navi Mumbai to Pune offers premium vehicles, punctual pickups, and discreet, professional chauffeurs. Focus on your work while we handle your commute efficiently and comfortably."
  },
  {
    "name": "Private Driver Cab Navi Mumbai to Pune",
    "description": "Enjoy the luxury and convenience of a private driver cab from Navi Mumbai to Pune. Our professional drivers offer personalized service, flexible schedules, and local knowledge, making your journey not just a trip, but a comfortable and stress-free experience."
  }
],
"tableData": [
  ["Navi Mumbai to Pune One Way Cab", "Round Trip Cab Navi Mumbai to Pune"],
  ["Cab from Vashi to Pune", "Panvel to Pune Taxi"],
  ["Affordable Cabs Navi Mumbai to Pune", "AC Taxi Navi Mumbai to Pune"],
  ["Online Cab Booking Navi Mumbai to Pune", "Sedan & SUV Hire Navi Mumbai to Pune"],
  ["Family Travel Cab Navi Mumbai to Pune", "Navi Mumbai to Pune Car Rental"],
  ["Budget Taxi Navi Mumbai to Pune Route", "Quick Ride Navi Mumbai to Pune"],
  ["24/7 Cab Navi Mumbai to Pune", "Corporate Cab Navi Mumbai to Pune"],
  ["Private Driver Cab Navi Mumbai to Pune", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Reliable Navi Mumbai to Pune Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and comfortable cab services from Navi Mumbai to Pune, ensuring a smooth and stress-free journey. Whether you’re traveling for business or leisure, our fleet of well-maintained, air-conditioned vehicles provides a relaxing environment for the approximately 150 km trip along one of Maharashtra’s busiest routes."
    },
    {
        "WhyChooseheading": "Customized Travel Packages for Every Need",
        "WhyChoosedescription": "Choose from flexible one-way rides, round-trip options, or multi-day packages that allow you to explore Pune and its surroundings at your own pace. Our team works closely with you to design itineraries that fit your schedule, including planned stops, sightseeing, or quick transfers."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Our Navi Mumbai to Pune cab fares are all-inclusive, covering fuel, tolls, driver allowances, and taxes. We provide upfront pricing with no hidden charges, giving you the confidence to select the best vehicle and package according to your budget and travel preferences."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in sanitized, air-conditioned sedans, SUVs, or tempo travellers designed to accommodate your group size comfortably. Our vehicles are regularly serviced to ensure reliability and comfort, making your journey safe and pleasant regardless of traffic conditions or weather."
    },
    {
        "WhyChooseheading": "Professional Drivers Experienced on Navi Mumbai-Pune Routes",
        "WhyChoosedescription": "Our drivers have extensive knowledge of the Navi Mumbai to Pune corridor, traffic patterns, and alternate routes to help avoid delays. They prioritize your safety and timely arrivals while providing courteous and professional service throughout your trip."
    },
    {
        "WhyChooseheading": "Flexible Scheduling and Personalized Travel Plans",
        "WhyChoosedescription": "Whether you require an early morning pickup or a late-night drop, we accommodate your timing preferences. Customize your trip with stops for refreshments, sightseeing detours, or overnight stays to make your travel experience more enjoyable and suited to your needs."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Dedicated Customer Care",
        "WhyChoosedescription": "Our booking system is available round-the-clock to assist you in scheduling your cab. Our customer support team is ready to handle last-minute requests, changes, or special accommodations to ensure a hassle-free journey from start to finish."
    },
    {
        "WhyChooseheading": "Ideal for Corporate Travelers, Families, and Groups",
        "WhyChoosedescription": "Whether traveling for work or with family and friends, our Navi Mumbai to Pune cab services cater to all. We focus on comfort, punctuality, and a smooth travel experience, making Meghana Cab your trusted partner for Maharashtra road trips."
    }
]

























    }

const faqData = [
    {
        question: "How can I book a cab from Navi Mumbai to Pune with Meghana Cab?",
        answer: "You can book your Navi Mumbai to Pune cab by calling Meghana Cab at +91 9075462128 or through our website for a quick and easy booking."
    },
    {
        question: "What vehicle options are available for the Navi Mumbai to Pune route?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for individuals, families, or groups."
    },
    {
        question: "Are Meghana Cab drivers experienced with the Navi Mumbai to Pune route?",
        answer: "Yes, our drivers know the best routes to ensure a safe and smooth journey from Navi Mumbai to Pune."
    },
    {
        question: "Is one-way cab service available from Navi Mumbai to Pune?",
        answer: "Yes, we provide both one-way and round-trip cab services for your convenience."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Our fares cover fuel, tolls, and driver charges. Additional costs may apply for parking or extra waiting time."
    },
    {
        question: "Are vehicles sanitized before trips?",
        answer: "Yes, all vehicles are thoroughly sanitized before every journey for your safety."
    },
    {
        question: "Is the Navi Mumbai to Pune cab service available 24/7?",
        answer: "Yes, Meghana Cab operates 24/7 to fit your travel schedule."
    },
    {
        question: "Can I request stops for meals or sightseeing during the trip?",
        answer: "Yes, stops can be arranged upon request. Please inform us while booking."
    },
    {
        question: "What payment methods do you accept?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How do I contact Meghana Cab to book a Navi Mumbai to Pune cab?",
        answer: "Call us anytime at +91 9075462128 to book your cab or get travel assistance."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service from Navi Mumbai to Pune. The driver was punctual and the ride very comfortable.”',
    },
    {
        name: 'Mrs. Anjali Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our Navi Mumbai to Pune trip smooth and hassle-free. Highly recommended!”',
    },
];










































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const naviMumbaiToPuneCabSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Navi Mumbai to Pune Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/navi-mumbai-to-pune-cab.jpg",
  "description": "Book reliable and affordable taxi service from Navi Mumbai to Pune with Meghana Cabs. One way, round trip, AC sedan, and SUV options available.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": [
    "Navi Mumbai to Pune One Way Cab",
    "Round Trip Cab Navi Mumbai to Pune",
    "Cab from Vashi to Pune",
    "Panvel to Pune Taxi",
    "Affordable Cabs Navi Mumbai to Pune",
    "AC Taxi Navi Mumbai to Pune",
    "Online Cab Booking Navi Mumbai to Pune",
    "Sedan & SUV Hire Navi Mumbai to Pune",
    "Family Travel Cab Navi Mumbai to Pune",
    "Navi Mumbai to Pune Car Rental",
    "Budget Taxi Navi Mumbai to Pune Route",
    "Quick Ride Navi Mumbai to Pune",
    "24/7 Cab Navi Mumbai to Pune",
    "Corporate Cab Navi Mumbai to Pune",
    "Private Driver Cab Navi Mumbai to Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Navi Mumbai to Pune Taxi Offers",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Navi Mumbai to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Cab Navi Mumbai to Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "AC Taxi Navi Mumbai to Pune"
        }
      }
    ]
  }
};






    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Pune Cab | Meghana Cabs</title>
  <meta
    name="description"
    content="Book reliable and affordable taxi service from Navi Mumbai to Pune with Meghana Cabs. One way, round trip, AC sedan, and SUV options available."
  />
  <meta
    name="keywords"
    content="Navi Mumbai to Pune One Way Cab, Round Trip Cab Navi Mumbai to Pune, Cab from Vashi to Pune, Panvel to Pune Taxi, Affordable Cabs Navi Mumbai to Pune, AC Taxi Navi Mumbai to Pune, Online Cab Booking Navi Mumbai to Pune, Sedan & SUV Hire Navi Mumbai to Pune, Family Travel Cab Navi Mumbai to Pune, Navi Mumbai to Pune Car Rental, Budget Taxi Navi Mumbai to Pune Route, Quick Ride Navi Mumbai to Pune, 24/7 Cab Navi Mumbai to Pune, Corporate Cab Navi Mumbai to Pune, Private Driver Cab Navi Mumbai to Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(naviMumbaiToPuneCabSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitopunecab;